export default __webpack_public_path__ + "images/quote_black.svg?01df3ec7c720360015471cd2a4775201";